export default {
  xs: 0,
  s: 480,
  m: 728,
  l: 1024,
  xl: 1280
}



// WEBPACK FOOTER //
// ./src/style/breakpoints.js